<template>
  <v-card class="dim-book-row-order-no-input">
    <v-card-title>EDIT ORDER</v-card-title>
    <v-card-text class="d-flex flex-column overflow-auto pa-4">
      <v-form ref="form">
        <v-text-field outlined
                      label="ORDER"
                      type="number"
                      :min="min"
                      :max="max"
                      :hint="hint"
                      persistent-hint
                      step="1"
                      v-model="orderNo"
                      :rules="orderNoRules"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && $emit('submit', orderNo)"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {computed, ref} from "@vue/composition-api";

export default {
  name: 'DimBookRowOrderNoInputModal',
  props: {
    min: {
      type: Number,
      default() {
        return 1
      },
    },
    max: {
      type: Number,
      default() {
        return 9999999;
      },
    },
    existingOrderNo: Array,
    initialOrderNo: Number,
  },
  setup(props, {root, emit}) {
    const hint = computed(() => {
      return `${props.min} - ${props.max}`
    })
    const orderNo = ref(props.initialOrderNo);
    const orderNoRules = ref([
      value => !!value || root.$t('rules.required'),
      value => parseInt(value) >= props.min || `Min. Order No.: ${props.min}`,
      value => parseInt(value) <= props.max || `Max. Order No.: ${props.max}`,
      value => props.existingOrderNo.indexOf(parseInt(value)) === -1 || 'Order No. already in use',
    ]);

    return {
      hint,
      orderNo,
      orderNoRules,
    }
  },
}
</script>
